import React, { useState } from 'react'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import Select from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Button } from '/src/components/common'

import './product_list.scss'

const ProductListItemImage = ({ title, image }) => {
  const [firstImage] = image

  // @todo, default fallback image.
  if (!firstImage) {
    return <></>
  }
  const { gatsbyImage } = firstImage.relationships.field_media_image_2

  return <GatsbyImage alt={title} image={gatsbyImage} />
}

export const ProductListItem = ({ title, path, relationships }) => {
  const { field_product_category, field_product_images } = relationships

  return (
    <div className="product-list-item">
      <Link className="product-link" to={path.alias}>
        {field_product_images && (
          <div className="product-image mb-3 d-flex justify-content-center">
            <ProductListItemImage title={title} image={field_product_images} />
          </div>
        )}
        <div className="product-category mb-1">
          {field_product_category.slice(0, 2).map(({ name }, index) => {
            return <span key={index}>{name}</span>
          })}
        </div>
        <div className="product-title">
          {title}
        </div>
      </Link>
    </div>
  )
}

const sortOptions = [
  {
    value: 'asc',
    label: 'ASC'
  },
  {
    value: 'desc',
    label: 'DESC'
  }
]

const ProductListSort = ({ setProductValues }) => {
  return <></>
  const onSortHandler = (sort) => {
    setProductValues(values => {
      return values.sort((a, b) => a.node.title.localeCompare(b.node.title))
    })
  }

  return (
    <>
      <Select 
        classNamePrefix="select-element sort"
        defaultValue={{
          value: 'asc',
          label: 'ASC'
        }}
        options={sortOptions}
        onChange={(value) => {
          onSortHandler(value)
        }}
      />
    </>
  )
}

export const ProductList = ({ products }) => {
  const [productLimit, setProductLimit] = useState(12) 
  const [productValues, setProductValues] = useState(products)
  const [productTotal] = useState(products.length)

  const handleLoadMore = () => {
    setProductLimit(prev => prev + 12)
  }

  return (
    <>
      <Row className="mt-5">
        <Col sm={12}>
          <div className="d-flex justify-content-end">
            <ProductListSort setProductValues={setProductValues} />
          </div>
        </Col>
      </Row>
      <Row className="product-list mt-5 mb-4">
        {productValues.slice(0, productLimit).map((product, index) => {
          return (
            <Col key={index} md={6} lg={4} className="product-list-item-container">
              <ProductListItem {...product.node} />
            </Col>
          )
        })}
      </Row>
      {productTotal > productLimit && (
        <Row>
          <Col sm={12}>
            <div className="load-more-container d-flex justify-content-center">
              <Button onClick={() => handleLoadMore()} variant="outline">
                Load More
                <FontAwesomeIcon icon={faChevronDown} />
              </Button>
            </div>
          </Col>
        </Row>
      )}
    </>
  )
}

export default ProductList